import { MaybeAsync } from '@angular/router';
import { from, isObservable, Observable, of } from 'rxjs';

export const maybeAsyncToObservable = <T>(
  input: MaybeAsync<T>
): Observable<T> => {
  if (isObservable(input)) {
    return input;
  }
  if (input instanceof Promise) {
    return from(input);
  }
  return of(input);
};
